import { HEAP_APP_ID, HEAP_ENVS } from 'constants/config';
import { useEffect } from 'react';
import { Heap } from './Heap/Heap';

const AnalyticsHeap = () => {
  useEffect(() => {
    const handlePageLoad = () => {
      const isHeapEnabledEnv = HEAP_ENVS.includes(window.location.hostname);
      if (isHeapEnabledEnv) {
        Heap.initialize(HEAP_APP_ID);
      }
    };

    if (document.readyState === 'complete') {
      handlePageLoad();
    } else {
      window.addEventListener('load', handlePageLoad);
    }

    return () => {
      window.removeEventListener('load', handlePageLoad);
    };
  }, []);

  return null;
};

export { AnalyticsHeap };
